import { render, staticRenderFns } from "./SchemeShowRoom.vue?vue&type=template&id=38778060&scoped=true"
import script from "./SchemeShowRoom.vue?vue&type=script&lang=js"
export * from "./SchemeShowRoom.vue?vue&type=script&lang=js"
import style0 from "./SchemeShowRoom.vue?vue&type=style&index=0&id=38778060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38778060",
  null
  
)

export default component.exports